import { FC } from "react";
import { Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import { useTranslation } from "react-i18next";
import { GraphLicenseStatus } from "../../types/user";
import { useStyles } from "../../theme/styles";

interface LicenseStatusTooltipProps {
    status?: GraphLicenseStatus;
    className?: string;
    useTeamsPhoneLabels?: boolean;
    licenseStatusCheckEnabled?: boolean;
}

const LicenseStatusTooltip: FC<LicenseStatusTooltipProps> = ({
    status = GraphLicenseStatus.Valid,
    className,
    useTeamsPhoneLabels = false,
    licenseStatusCheckEnabled = true,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();

    if (!licenseStatusCheckEnabled) {
        return null;
    }

    const getLicenseStatusIcon = (licenseStatus: GraphLicenseStatus) => {
        switch (licenseStatus) {
            case GraphLicenseStatus.Valid:
                return <InfoIcon color="success" />;
            case GraphLicenseStatus.Missing:
            case GraphLicenseStatus.Suspended:
                return <WarningIcon color="error" />;
            case GraphLicenseStatus.Expired:
            case GraphLicenseStatus.ExpiringSoon:
                return <WarningIcon color="warning" />;
            default:
                return <InfoIcon color="success" />;
        }
    };

    const getTranslationKey = () => {
        const baseStatus = GraphLicenseStatus[status];
		
        if (useTeamsPhoneLabels) {
            return `UserList.LicenseStatus.${baseStatus}TeamsPhone`;
        }

        return `UserList.LicenseStatus.${baseStatus}`;
    };

    return (
        <Tooltip
            className={className || classes.tooltip}
            title={t(getTranslationKey())}
        >
            {getLicenseStatusIcon(status)}
        </Tooltip>
    );
};

export default LicenseStatusTooltip;